import { useContext } from "react";
import { UserDetailsContext } from "../components/UserDetailsManager";

export default function useUserDetails() {
  const { details, updateUserDetails, updateTimestamp } =
    useContext(UserDetailsContext);

  return {
    clinic: details?.clinic,
    user: details?.user,
    updateUserDetails,
    updateTimestamp,
  };
}
